import React, {useContext, useEffect} from 'react'
import { StateContext } from '../../context/GlobalState.jsx'
import {Col, Container, Row, Spinner} from "react-bootstrap";

function SearchItem() {

    const {getPartsSearch, searchURL,  partsSearch, searchRequest} = useContext(StateContext);


    useEffect(() => {
        getPartsSearch(searchRequest)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [searchURL])


 //  console.log(searchURL)


    // render JSX
    return (
        <div >
            <Container>
                <Row className="center-text">
                    <Col>

                        <div className="App">
                            <div>
                                <section className="products">
                                    {partsSearch.length > 0 ? partsSearch :  <div className="center-text items padTop"><Spinner animation="border" /></div>}
                                </section>
                            </div>

                        </div>
                    </Col>

                </Row>
            </Container>


        </div>
    )
}

export default SearchItem
